// import React, { useEffect, useState } from "react";
// import Main from "../pages/Main";
// import { exportTable } from "../utils/downloadExcel";
// import { fetchBillHistory } from "../api/rechages.Api";
// import { autoDateFormat } from "../utils/autoDateFormate";
// import { formatAmount } from "../utils/formatAmount";

// import WalletHistoryBar from "../components/WalletHistoryBar";
// import { useTxnDocActions } from "../hooks/useTxnDocActions";
// import {
//   ListingFilters,
//   ListingPagination,
//   SortableTh,
//   CopyText,
//   AppBreadcrumbs,
//   RowActions,
//   StatusBadge,
//   useListingState,
//   RECHARGE_STATUS_OPTIONS,
// } from "../components/listing";
// import { useNotify } from "../context/NotifyContext";

// const BBPSPayHistory = () => {
//   const { notify } = useNotify();
//   const listing = useListingState({ sortBy: "date", sortDir: "desc" });
//   const { viewTxn, printTxn, pdfTxn } = useTxnDocActions("bbps");
//   const [tableData, setTableData] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalLedgers, setTotalbyAll] = useState(0);
//   const [totalAmount, setTotalAmount] = useState(0);

//   const fetch_recharges = async () => {
//     try {
//       const result = await fetchBillHistory(listing.query);
//       if (result?.success) {
//         const response = result?.data;
//         setTableData(response?.utilityPayments || response?.recharge || []);
//         setTotalPages(response?.pagination?.totalPages || 1);
//         setTotalbyAll(response?.pagination?.total || 0);
//         setTotalAmount(Number(response?.totalAmount) || 0);
//       } else {
//         notify(result?.message || "Server Error", "error");
//       }
//     } catch (error) {}
//   };

//   useEffect(() => {
//     fetch_recharges();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     listing.page,
//     listing.limit,
//     listing.startDate,
//     listing.endDate,
//     listing.debouncedSearch,
//     listing.sortBy,
//     listing.sortDir,
//     listing.status,
//   ]);

//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-4">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "JSS MANAGEMENT AND SUPPLY BBPS Bill Payment" },
//             { label: "New Transaction" },
//           ]}
//         />

//         <WalletHistoryBar title="BBPS Transactions" to="/main-wallet-ledger">
//           <div className="flex items-center gap-2 min-w-0">
//             <p className="text-[13px] md:text-[15px] font-semibold text-[var(--text-dark)] m-0">
//               BBPS Transactions
//             </p>
//           </div>
//         </WalletHistoryBar>

//         <div className="ds-card text-sm">
//           <ListingFilters
//             onClear={listing.clearFilters}
//             startDate={listing.startDate}
//             endDate={listing.endDate}
//             onStartDate={listing.setStartDate}
//             onEndDate={listing.setEndDate}
//             search={listing.search}
//             onSearch={listing.setSearch}
//             searchPlaceholder="Search"
//             status={listing.status}
//             onStatus={listing.setStatus}
//             statusOptions={RECHARGE_STATUS_OPTIONS}
//             onExport={() =>
//               exportTable(
//                 "bbps-history",
//                 [
//                   { label: "S NO.", value: (_r, i) => (listing.page - 1) * listing.limit + i + 1 },
//                   { label: "Date", value: (r) => (r?.createdAt ? autoDateFormat(r.createdAt) : "") },
//                   { label: "Branch Code", value: (r) => r?.userId?.userName ?? "" },
//                   { label: "CSP Mobile", value: (r) => r?.userId?.phone ?? "" },
//                   { label: "Customer Mobile", key: "mobile" },
//                   { label: "Amount", key: "amount" },
//                   { label: "Description", value: (r) => r?.paysprintResponse?.message ?? "" },
//                   { label: "Order ID", key: "txnId" },
//                   { label: "Status", value: (r) => r?.status ?? r?.transactionStatus ?? "" },
//                 ],
//                 tableData,
//                 notify
//               )
//             }
//           />

//           <div className="ds-table-wrap ds-scroll">
//             <table className="ds-table ds-table-listing min-w-[700px]">
//               <thead>
//                 <tr>
//                   <th>S NO.</th>
//                   <SortableTh
//                     label="Date"
//                     sortKey="date"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th>Branch Code</th>
//                   <th>CSP Mobile</th>
//                   <th>Customer Mobile</th>
//                   <SortableTh
//                     label="Amount"
//                     sortKey="amount"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th>Description</th>
//                   <th>Order ID</th>
//                   <SortableTh
//                     label="Status"
//                     sortKey="status"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th className="ds-th-actions">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData?.length === 0 ? (
//                   <tr>
//                     <td colSpan="10" className="text-center text-[var(--text-muted)]">
//                       NO DATA AVAILABLE IN TABLE
//                     </td>
//                   </tr>
//                 ) : (
//                   tableData?.map((row, index) => (
//                     <tr key={row?._id || index}>
//                       <td>{(listing.page - 1) * listing.limit + index + 1}</td>
//                       <td>{row?.createdAt ? autoDateFormat(row.createdAt) : "--"}</td>
//                       <td>{row?.userId?.userName ?? "--"}</td>
//                       <td>{row?.userId?.phone ?? "--"}</td>
//                       <td>{row?.mobile ?? "--"}</td>
//                       <td className="ds-td-amount">{formatAmount(row?.amount) ?? "--"}</td>
//                       <td>{row?.paysprintResponse?.message ?? "--"}</td>
//                       <td>
//                         <CopyText value={row?.txnId} label="Order ID" />
//                       </td>
//                       <td>
//                         <StatusBadge status={row?.status ?? row?.transactionStatus} />
//                       </td>
//                       <td>
//                         <RowActions
//                           onView={() => viewTxn(row)}
//                           onPdf={() => pdfTxn(row)}
//                           onPrint={() => printTxn(row)}
//                         />
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//               <tfoot>
//                 <tr className="ds-table-total">
//                   <td colSpan={5} className="ds-table-total__label">
//                     Total Amount
//                   </td>
//                   <td className="ds-table-total__value">₹ {formatAmount(totalAmount)}</td>
//                   <td colSpan={4}></td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>

//           <ListingPagination
//             page={listing.page}
//             limit={listing.limit}
//             total={totalLedgers}
//             totalPages={totalPages}
//             onPageChange={listing.setPage}
//             onLimit={listing.setLimit}
//             limitOptions={[10, 50, 100, 500]}
//           />
//         </div>
//       </div>
//     </Main>
//   );
// };

// export default BBPSPayHistory;



// import React, { useEffect, useState } from "react";
// import Main from "../pages/Main";
// import { exportTable } from "../utils/downloadExcel";
// import { fetchBillHistory } from "../api/rechages.Api";
// import { autoDateFormat } from "../utils/autoDateFormate";
// import { formatAmount } from "../utils/formatAmount";

// import WalletHistoryBar from "../components/WalletHistoryBar";
// import { useTxnDocActions } from "../hooks/useTxnDocActions";
// import {
//   ListingFilters,
//   ListingPagination,
//   SortableTh,
//   CopyText,
//   AppBreadcrumbs,
//   RowActions,
//   StatusBadge,
//   useListingState,
//   RECHARGE_STATUS_OPTIONS,
// } from "../components/listing";
// import { useNotify } from "../context/NotifyContext";

// // Backend field names alag ho sakte hain, isliye fallbacks diye hain.
// // Wingpay payment response: orderId, apiTxnId, operatorRefId, status, transaction_date
// const getOrderId = (r) => r?.txnId ?? r?.orderId;
// const getOperatorRef = (r) => r?.operatorRefId ?? r?.operatorRef ?? r?.wingpayResponse?.operatorRefId;
// const getCardLast4 = (r) => r?.last4DigitCardNumber ?? r?.Last4DigitCardNumber ?? r?.cardLast4 ?? r?.canumber;
// const getDescription = (r) =>
//   r?.wingpayResponse?.message ?? r?.paysprintResponse?.message ?? r?.message ?? "";
// const getDate = (r) => r?.transaction_date ?? r?.createdAt;
// const getStatus = (r) => r?.status ?? r?.transactionStatus;

// const maskCard = (v) => (v ? `XXXX ${String(v).slice(-4)}` : "");

// const TOTAL_COLS = 12;

// const BBPSPayHistory = () => {
//   const { notify } = useNotify();
//   const listing = useListingState({ sortBy: "date", sortDir: "desc" });
//   const { viewTxn, printTxn, pdfTxn } = useTxnDocActions("bbps");
//   const [tableData, setTableData] = useState([]);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalLedgers, setTotalbyAll] = useState(0);
//   const [totalAmount, setTotalAmount] = useState(0);

//   const fetch_recharges = async () => {
//     try {
//       const result = await fetchBillHistory(listing.query);
//       if (result?.success) {
//         const response = result?.data;
//         setTableData(response?.utilityPayments || response?.recharge || []);
//         setTotalPages(response?.pagination?.totalPages || 1);
//         setTotalbyAll(response?.pagination?.total || 0);
//         setTotalAmount(Number(response?.totalAmount) || 0);
//       } else {
//         notify(result?.message || "Server Error", "error");
//       }
//     } catch (error) {
//       notify("Server Error", "error");
//     }
//   };

//   useEffect(() => {
//     fetch_recharges();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     listing.page,
//     listing.limit,
//     listing.startDate,
//     listing.endDate,
//     listing.debouncedSearch,
//     listing.sortBy,
//     listing.sortDir,
//     listing.status,
//   ]);

//   return (
//     <Main showRightPanel={false} showInfoText={false}>
//       <div className="mt-4">
//         <AppBreadcrumbs
//           items={[
//             { label: "Dashboard", to: "/" },
//             { label: "JSS MANAGEMENT AND SUPPLY BBPS Bill Payment" },
//             { label: "New Transaction" },
//           ]}
//         />

//         <WalletHistoryBar title="BBPS Transactions" to="/main-wallet-ledger">
//           <div className="flex items-center gap-2 min-w-0">
//             <p className="text-[13px] md:text-[15px] font-semibold text-[var(--text-dark)] m-0">
//               BBPS Transactions
//             </p>
//           </div>
//         </WalletHistoryBar>

//         <div className="ds-card text-sm">
//           <ListingFilters
//             onClear={listing.clearFilters}
//             startDate={listing.startDate}
//             endDate={listing.endDate}
//             onStartDate={listing.setStartDate}
//             onEndDate={listing.setEndDate}
//             search={listing.search}
//             onSearch={listing.setSearch}
//             searchPlaceholder="Search"
//             status={listing.status}
//             onStatus={listing.setStatus}
//             statusOptions={RECHARGE_STATUS_OPTIONS}
//             onExport={() =>
//               exportTable(
//                 "bbps-history",
//                 [
//                   { label: "S NO.", value: (_r, i) => (listing.page - 1) * listing.limit + i + 1 },
//                   { label: "Date", value: (r) => (getDate(r) ? autoDateFormat(getDate(r)) : "") },
//                   { label: "Branch Code", value: (r) => r?.userId?.userName ?? "" },
//                   { label: "CSP Mobile", value: (r) => r?.userId?.phone ?? "" },
//                   { label: "Customer Mobile", value: (r) => r?.mobile ?? r?.MobileNo ?? "" },
//                   { label: "Card No.", value: (r) => maskCard(getCardLast4(r)) },
//                   { label: "Amount", key: "amount" },
//                   { label: "Description", value: (r) => getDescription(r) },
//                   { label: "Order ID", value: (r) => getOrderId(r) ?? "" },
//                   { label: "Operator Ref ID", value: (r) => getOperatorRef(r) ?? "" },
//                   { label: "Status", value: (r) => getStatus(r) ?? "" },
//                 ],
//                 tableData,
//                 notify
//               )
//             }
//           />

//           <div className="ds-table-wrap ds-scroll">
//             <table className="ds-table ds-table-listing min-w-[900px]">
//               <thead>
//                 <tr>
//                   <th>S NO.</th>
//                   <SortableTh
//                     label="Date"
//                     sortKey="date"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th>Branch Code</th>
//                   <th>CSP Mobile</th>
//                   <th>Customer Mobile</th>
//                   <th>Card No.</th>
//                   <SortableTh
//                     label="Amount"
//                     sortKey="amount"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th>Description</th>
//                   <th>Order ID</th>
//                   <th>Operator Ref ID</th>
//                   <SortableTh
//                     label="Status"
//                     sortKey="status"
//                     activeKey={listing.sortBy}
//                     direction={listing.sortDir}
//                     onSort={listing.toggleSort}
//                   />
//                   <th className="ds-th-actions">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData?.length === 0 ? (
//                   <tr>
//                     <td colSpan={TOTAL_COLS} className="text-center text-[var(--text-muted)]">
//                       NO DATA AVAILABLE IN TABLE
//                     </td>
//                   </tr>
//                 ) : (
//                   tableData?.map((row, index) => (
//                     <tr key={row?._id || index}>
//                       <td>{(listing.page - 1) * listing.limit + index + 1}</td>
//                       <td>{getDate(row) ? autoDateFormat(getDate(row)) : "--"}</td>
//                       <td>{row?.userId?.userName ?? "--"}</td>
//                       <td>{row?.userId?.phone ?? "--"}</td>
//                       <td>{row?.mobile ?? row?.MobileNo ?? "--"}</td>
//                       <td>{maskCard(getCardLast4(row)) || "--"}</td>
//                       <td className="ds-td-amount">{formatAmount(row?.amount) ?? "--"}</td>
//                       <td>{getDescription(row) || "--"}</td>
//                       <td>
//                         <CopyText value={getOrderId(row)} label="Order ID" />
//                       </td>
//                       <td>
//                         {getOperatorRef(row) ? (
//                           <CopyText value={getOperatorRef(row)} label="Operator Ref ID" />
//                         ) : (
//                           "--"
//                         )}
//                       </td>
//                       <td>
//                         <StatusBadge status={getStatus(row)} />
//                       </td>
//                       <td>
//                         <RowActions
//                           onView={() => viewTxn(row)}
//                           onPdf={() => pdfTxn(row)}
//                           onPrint={() => printTxn(row)}
//                         />
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//               <tfoot>
//                 <tr className="ds-table-total">
//                   <td colSpan={6} className="ds-table-total__label">
//                     Total Amount
//                   </td>
//                   <td className="ds-table-total__value">₹ {formatAmount(totalAmount)}</td>
//                   <td colSpan={5}></td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>

//           <ListingPagination
//             page={listing.page}
//             limit={listing.limit}
//             total={totalLedgers}
//             totalPages={totalPages}
//             onPageChange={listing.setPage}
//             onLimit={listing.setLimit}
//             limitOptions={[10, 50, 100, 500]}
//           />
//         </div>
//       </div>
//     </Main>
//   );
// };

// export default BBPSPayHistory;


import React, { useEffect, useState, useCallback } from "react";
import Main from "../pages/Main";
import { exportTable } from "../utils/downloadExcel";
import { fetch_cc_history } from "../api/creditCardBillApi";
import { autoDateFormat } from "../utils/autoDateFormate";
import { formatAmount } from "../utils/formatAmount";

import WalletHistoryBar from "../components/WalletHistoryBar";
import { useTxnDocActions } from "../hooks/useTxnDocActions";
import {
  ListingFilters,
  ListingPagination,
  SortableTh,
  CopyText,
  AppBreadcrumbs,
  RowActions,
  StatusBadge,
  useListingState,
  RECHARGE_STATUS_OPTIONS,
} from "../components/listing";
import { useNotify } from "../context/NotifyContext";

const TOTAL_COLS = 15;

const maskCard = (last4) => (last4 ? `XXXX ${String(last4).slice(-4)}` : "");

// Backend (CreditCardBillPayment) fields
const getDescription = (r) => {
  if (r?.status === "FAILED") {
    return r?.failureReason || r?.wingpayResponse?.message || "Payment failed";
  }
  if (r?.status === "PENDING") return "Payment is being processed";
  return r?.wingpayResponse?.message || "Payment successful";
};

const BBPSPayHistory = () => {
  const { notify } = useNotify();
  const listing = useListingState({ sortBy: "date", sortDir: "desc" });
  const { viewTxn, printTxn, pdfTxn } = useTxnDocActions("bbps");

  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalLedgers, setTotalbyAll] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchHistory = useCallback(async () => {
    setLoading(true);
    try {
      const params = {
        page: listing.page,
        limit: listing.limit,
        sortBy: listing.sortBy,
        sortDir: listing.sortDir,
      };
      if (listing.startDate) params.startDate = listing.startDate;
      if (listing.endDate) params.endDate = listing.endDate;
      if (listing.debouncedSearch) params.search = listing.debouncedSearch;
      if (listing.status) params.status = listing.status;

      const result = await fetch_cc_history(params);

      if (result?.success) {
        const response = result?.data;
        setTableData(response?.utilityPayments || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalbyAll(response?.pagination?.total || 0);
        setTotalAmount(Number(response?.totalAmount) || 0);
      } else {
        notify(result?.message || "Server Error", "error");
      }
    } catch (error) {
      notify("Server Error", "error");
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listing.page,
    listing.limit,
    listing.startDate,
    listing.endDate,
    listing.debouncedSearch,
    listing.sortBy,
    listing.sortDir,
    listing.status,
  ]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return (
    <Main showRightPanel={false} showInfoText={false}>
      <div className="mt-4">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "JSS MANAGEMENT AND SUPPLY BBPS Bill Payment" },
            { label: "Credit Card Bill History" },
          ]}
        />

        

        <WalletHistoryBar title="BBPS Transactions" to="/add-money-ledger">
          <div className="flex items-center justify-between gap-2 min-w-0 w-full">
            <p className="text-[13px] md:text-[15px] font-semibold text-[var(--text-dark)] m-0">
              BBPS Transactions
            </p>
            <button
              type="button"
              onClick={fetchHistory}
              disabled={loading}
              className="ds-btn ds-btn-secondary"
            >
              {loading ? "Refreshing..." : "Refresh"}
            </button>
          </div>
        </WalletHistoryBar>

        <div className="ds-card text-sm">
          <ListingFilters
            onClear={listing.clearFilters}
            startDate={listing.startDate}
            endDate={listing.endDate}
            onStartDate={listing.setStartDate}
            onEndDate={listing.setEndDate}
            search={listing.search}
            onSearch={listing.setSearch}
            searchPlaceholder="Search order, mobile, card, ref"
            status={listing.status}
            onStatus={listing.setStatus}
            statusOptions={RECHARGE_STATUS_OPTIONS}
            onExport={() =>
              exportTable(
                "bbps-history",
                [
                  { label: "S NO.", value: (_r, i) => (listing.page - 1) * listing.limit + i + 1 },
                  { label: "Date", value: (r) => (r?.createdAt ? autoDateFormat(r.createdAt) : "") },
                  { label: "Branch Code", value: (r) => r?.userId?.userName ?? "" },
                  { label: "CSP Mobile", value: (r) => r?.userId?.phone ?? "" },
                  { label: "Customer Name", value: (r) => r?.customerName ?? "" },
                  { label: "Customer Mobile", value: (r) => r?.mobile ?? "" },
                  { label: "Card No.", value: (r) => maskCard(r?.last4DigitCardNumber) },
                  { label: "Amount", value: (r) => r?.amount ?? 0 },
                  { label: "Charges", value: (r) => r?.charges ?? 0 },
                  { label: "Total Debit", value: (r) => r?.totalDebit ?? 0 },
                  { label: "Description", value: (r) => getDescription(r) },
                  { label: "Order ID", value: (r) => r?.orderId ?? r?.txnId ?? "" },
                  { label: "Operator Ref ID", value: (r) => r?.operatorRefId ?? "" },
                  { label: "Status", value: (r) => r?.status ?? "" },
                ],
                tableData,
                notify
              )
            }
          />

          <div className="ds-table-wrap ds-scroll">
            <table className="ds-table ds-table-listing min-w-[1200px]">
              <thead>
                <tr>
                  <th>S NO.</th>
                  <SortableTh
                    label="Date"
                    sortKey="date"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <th>Branch Code</th>
                  <th>CSP Mobile</th>
                  <th>Customer Name</th>
                  <th>Customer Mobile</th>
                  <th>Card No.</th>
                  <SortableTh
                    label="Amount"
                    sortKey="amount"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <th>Charges</th>
                  <th>Total Debit</th>
                  {/* <th>Description</th> */}
                  <th>Order ID</th>
                  <th>Operator Ref ID</th>
                  <SortableTh
                    label="Status"
                    sortKey="status"
                    activeKey={listing.sortBy}
                    direction={listing.sortDir}
                    onSort={listing.toggleSort}
                  />
                  <th className="ds-th-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading && tableData.length === 0 ? (
                  <tr>
                    <td colSpan={TOTAL_COLS} className="text-center text-[var(--text-muted)]">
                      Loading...
                    </td>
                  </tr>
                ) : tableData.length === 0 ? (
                  <tr>
                    <td colSpan={TOTAL_COLS} className="text-center text-[var(--text-muted)]">
                      NO DATA AVAILABLE IN TABLE
                    </td>
                  </tr>
                ) : (
                  tableData.map((row, index) => (
                    <tr key={row?._id || index}>
                      <td>{(listing.page - 1) * listing.limit + index + 1}</td>
                      <td>{row?.createdAt ? autoDateFormat(row.createdAt) : "--"}</td>
                      <td>{row?.userId?.userName ?? "--"}</td>
                      <td>{row?.userId?.phone ?? "--"}</td>
                      <td>{row?.customerName || "--"}</td>
                      <td>{row?.mobile ?? "--"}</td>
                      <td>{maskCard(row?.last4DigitCardNumber) || "--"}</td>
                      <td className="ds-td-amount">{formatAmount(row?.amount) ?? "--"}</td>
                      <td>{formatAmount(row?.charges ?? 0)}</td>
                      <td>{formatAmount(row?.totalDebit ?? 0)}</td>
                      {/* <td>{getDescription(row)}</td> */}
                      <td>
                        <CopyText value={row?.orderId ?? row?.txnId} label="Order ID" />
                      </td>
                      <td>
                        {row?.operatorRefId ? (
                          <CopyText value={row.operatorRefId} label="Operator Ref ID" />
                        ) : (
                          "--"
                        )}
                      </td>
                      <td>
                        <StatusBadge status={row?.status} />
                      </td>
                      <td>
                        <RowActions
                          onView={() => viewTxn(row)}
                          onPdf={() => pdfTxn(row)}
                          onPrint={() => printTxn(row)}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr className="ds-table-total">
                  <td colSpan={7} className="ds-table-total__label">
                    Total Amount (Success)
                  </td>
                  <td className="ds-table-total__value">₹ {formatAmount(totalAmount)}</td>
                  <td colSpan={7}></td>
                </tr>
              </tfoot>
            </table>
          </div>

          <ListingPagination
            page={listing.page}
            limit={listing.limit}
            total={totalLedgers}
            totalPages={totalPages}
            onPageChange={listing.setPage}
            onLimit={listing.setLimit}
            limitOptions={[10, 50, 100, 500]}
          />
        </div>
      </div>
    </Main>
  );
};

export default BBPSPayHistory;